// Hell/Dunkel-Umschaltung. Die Wahl liegt beim Benutzer, Vorgabe ist die
// Systemeinstellung. Die Klasse hängt am <html>, passend zu @custom-variant dark.
import { useEffect, useState } from 'react';
import { istNativ } from './plattform';

export type Thema = 'hell' | 'dunkel' | 'system';
const SCHLUESSEL = 'lp_thema';

function gespeichert(): Thema {
  try {
    const w = localStorage.getItem(SCHLUESSEL);
    if (w === 'hell' || w === 'dunkel' || w === 'system') return w;
  } catch { /* egal */ }
  return 'system';
}

function anwenden(thema: Thema) {
  const dunkel = thema === 'dunkel'
    || (thema === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dunkel);
  statusleisteAnpassen(dunkel);
}

/**
 * Schrift der Statusleiste an das Thema angleichen.
 *
 * In der App läuft der Inhalt bis unter die Uhr. Bleibt die Statusleiste hell
 * beschriftet, steht auf hellem Grund Weiß auf Weiß — Uhrzeit und Empfang sind
 * dann unsichtbar. Nur in der nativen Hülle; der Browser hat keine.
 */
function statusleisteAnpassen(dunkel: boolean) {
  if (!istNativ()) return;
  void (async () => {
    try {
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      // Style.Dark heißt bei Apple „dunkler Inhalt": schwarze Schrift für
      // hellen Grund. Die Benennung ist verdreht, deshalb steht es hier.
      await StatusBar.setStyle({ style: dunkel ? Style.Light : Style.Dark });
    } catch { /* ohne Plugin bleibt es bei der Vorgabe des Systems */ }
  })();
}

export function useThema() {
  const [thema, setThema] = useState<Thema>(gespeichert);

  useEffect(() => {
    anwenden(thema);
    try { localStorage.setItem(SCHLUESSEL, thema); } catch { /* egal */ }

    if (thema !== 'system') return;
    // Der Systemwechsel muss auch ohne Neuladen ankommen.
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const beiWechsel = () => anwenden('system');
    mq.addEventListener('change', beiWechsel);
    return () => mq.removeEventListener('change', beiWechsel);
  }, [thema]);

  return { thema, setThema };
}
